import styled from 'styled-components';
import theme, { rems } from 'fe-appdir-lib-theme';

const AppCardName = styled.h3`
  margin: 18px 0 0;
  font-size: ${(props) => (props.large ? rems(24) : rems(18))};
  font-weight: bold;
  color: ${theme.colorBase};
`;

AppCardName.displayName = 'AppCardName';

export { AppCardName };
